

import React, { useState, useEffect } from "react";
import { Radio, Card, Row, Col } from "antd";
import "./Claim.css";
import IntimateClaims from "./IntimateClaims";
import ClaimDetails from "./ClaimDetails";
import { useSelector } from "react-redux";
import { getUserData } from "../login/LoginSlice";
import { useNavigate, useLocation } from "react-router-dom";

const claimOptions = [
  { value: 0, label: "Claim Details", optionId: 4 },
  { value: 1, label: "Intimate Claim", optionId: 5 },
];

const Index = () => {
  const [activeComponent, setActiveComponent] = useState(0);
  const [heading, setHeading] = useState("Claim Details");
  const Data = useSelector(getUserData);
  const navigate = useNavigate();
  const location = useLocation();

  const userModule = Data?.module_data?.find((module) => module.module_id === 3);
  const userOptionIds = userModule?.module_option_ids || [];

  const handleComponentChange = (e) => {
    const component = e.target.value;
    setActiveComponent(component);
    console.log("Selected Component:", component);
    setHeading(claimOptions.find((option) => option.value === component)?.label || "Claim Details");
    navigate(`/corporate/Claims?tab=${component}`);
  };

  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromQuery = parseInt(params.get("tab"));
    const tabFromState = location.state?.activeTab;
  
    if (!isNaN(tabFromQuery)) {
      setActiveComponent(tabFromQuery);
      setHeading(
        claimOptions.find((option) => option.value === tabFromQuery)?.label || "Claim Details"
      );
    } else if (!isNaN(tabFromState)) {
      setActiveComponent(tabFromState);
      setHeading(
        claimOptions.find((option) => option.value === tabFromState)?.label || "Claim Details"
      );
    }
  }, [location.search, location.state]);
  
  return (
    <div>
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            className="cust-cd-card mb-3"
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "700",
                  fontSize: "20px",
                }}
              >
                <span className="corp-title">{heading}</span>

                <Radio.Group
                  block
                  onChange={handleComponentChange}
                  value={activeComponent}
                  buttonStyle="solid"
                  optionType="button"
                >
                  {claimOptions.map(({ value, label, optionId }) => (
                    <Radio
                      key={value}
                      value={value}
                      disabled={!userOptionIds.includes(optionId)}
                    >
                      {label}
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            }
            bordered={false}
          ></Card>

          {activeComponent === 0 && <ClaimDetails />}
          {activeComponent === 1 && <IntimateClaims />}
        </Col>
      </Row>
    </div>
  );
};

export default Index;


